import { buildStateEvent, GenericStateEvent } from '../../../common-redux'
import { generalProblem } from './model'

export interface generalProblemStateEvent<T> extends GenericStateEvent<T> {}

export const GetAllGeneralProblemSuccessEvent = {
    type: 'GetAllGeneralProblemSuccessEvent',
    build: (payload: generalProblem) => buildStateEvent(GetAllGeneralProblemSuccessEvent.type, payload)
}
